import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { CopyTextArea } from 'foundations-components/transitional/components/CopyTextArea';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function CopySection({
  textToCopy,
  description,
  onCopyClick
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      children: [description && /*#__PURE__*/_jsx("div", {
        "data-test-id": "copy-section-description",
        children: description
      }), /*#__PURE__*/_jsx(CopyButton, {
        use: "link",
        value: textToCopy,
        "data-test-id": "copy-section-copy-button",
        onClick: onCopyClick,
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "shared.copySection.copyButton"
        })
      })]
    }), /*#__PURE__*/_jsx(CopyTextArea, {
      use: "code",
      value: textToCopy,
      buttonRowRenderer: () => null
    })]
  });
}